import axios from 'axios';
import { API_BASE_URL } from '../../../../lib/constants';

export const fetchAllPostOpStatuses = async (uhidNo) => {
  const formChecks = await Promise.allSettled([
    axios.get(`${API_BASE_URL}/get_post_operative_order/${uhidNo}`),
    axios.get(`${API_BASE_URL}/get_post_op_instruction/${uhidNo}`),
    axios.get(`${API_BASE_URL}/get_alderete_score/${uhidNo}`),
    axios.get(`${API_BASE_URL}/get_assessment/${uhidNo}`),
    axios.get(`${API_BASE_URL}/get_post_op_handover/${uhidNo}`)
  ]);
  return formChecks;
};
